import {
  Chat,
  ChatAvailableSourcesResponse,
  ChatContactsGetParams,
  ChatContactsResponse,
  ChatCreateForm,
  ChatFilesGetParams,
  ChatFilesResponse,
  ChatMarkReadForm,
  ChatMarkReadResponse,
  ChatMembersGetParams,
  ChatMembersResponse,
  ChatMessagesGetParams,
  ChatMessagesResponse,
  ChatResponse,
  ChatSendMessageForm,
  ChatSendMessageResponse,
  ChatUnreadCountResponse,
  ChatUpdateForm,
  ChatsGetParams,
  ChatsResponse,
  MessengerSubscriptionTokenForm,
  MessengerSubscriptionTokenResponse,
  MessengerTokenResponse,
} from 'src/types';
import axios, { ENDPOINTS } from 'src/utils/axios';

export const getChats = async (params: ChatsGetParams = {}): Promise<ChatsResponse> => {
  const response = await axios.get<ChatsResponse>(ENDPOINTS.app.chats, { params });
  return response.data;
};

export const createChat = async (data: ChatCreateForm): Promise<ChatResponse> => {
  const response = await axios.post<ChatResponse>(ENDPOINTS.app.chats, data);
  return response.data;
};

export const getChat = async (chatId: Chat['id']): Promise<ChatResponse> => {
  const response = await axios.get<ChatResponse>(`${ENDPOINTS.app.chats}/${chatId}`);
  return response.data;
};

export const updateChat = async (data: ChatUpdateForm): Promise<ChatResponse> => {
  const { chat_id, ...body } = data;
  const response = await axios.patch<ChatResponse>(`${ENDPOINTS.app.chats}/${chat_id}`, body);
  return response.data;
};

export const getChatMembers = async (
  params: ChatMembersGetParams
): Promise<ChatMembersResponse> => {
  const { chat_id, ...rest } = params;
  const response = await axios.get<ChatMembersResponse>(
    `${ENDPOINTS.app.chats}/${chat_id}/members`,
    { params: rest }
  );
  return response.data;
};

export const getChatMessages = async (
  params: ChatMessagesGetParams
): Promise<ChatMessagesResponse> => {
  const { chat_id, ...rest } = params;
  const response = await axios.get<ChatMessagesResponse>(
    `${ENDPOINTS.app.chats}/${chat_id}/messages`,
    { params: rest }
  );
  return response.data;
};

export const sendChatMessage = async (
  data: ChatSendMessageForm
): Promise<ChatSendMessageResponse> => {
  const { chat_id, ...body } = data;
  const response = await axios.post<ChatSendMessageResponse>(
    `${ENDPOINTS.app.chats}/${chat_id}/messages`,
    body
  );
  return response.data;
};

export const markChatRead = async (data: ChatMarkReadForm): Promise<ChatMarkReadResponse> => {
  const { chat_id, ...body } = data;
  const response = await axios.put<ChatMarkReadResponse>(
    `${ENDPOINTS.app.chats}/${chat_id}/read`,
    body
  );
  return response.data;
};

export const getChatFiles = async (params: ChatFilesGetParams): Promise<ChatFilesResponse> => {
  const { chat_id, ...rest } = params;
  const response = await axios.get<ChatFilesResponse>(`${ENDPOINTS.app.chats}/${chat_id}/files`, {
    params: rest,
  });
  return response.data;
};

export const getAvailableChatSources = async (): Promise<ChatAvailableSourcesResponse> => {
  const response = await axios.get<ChatAvailableSourcesResponse>(
    `${ENDPOINTS.app.chats}/available-sources`
  );
  return response.data;
};

export const getChatContacts = async (
  params: ChatContactsGetParams
): Promise<ChatContactsResponse> => {
  const response = await axios.get<ChatContactsResponse>(`${ENDPOINTS.app.chats}/contacts`, {
    params,
  });
  return response.data;
};

export const getChatsUnreadCount = async (): Promise<ChatUnreadCountResponse> => {
  const response = await axios.get<ChatUnreadCountResponse>(
    `${ENDPOINTS.app.chats}/unread-count`
  );
  return response.data;
};

export const getMessengerToken = async (): Promise<MessengerTokenResponse> => {
  const response = await axios.get<MessengerTokenResponse>(ENDPOINTS.app.messengerToken);
  return response.data;
};

export const getMessengerSubscriptionToken = async (
  data: MessengerSubscriptionTokenForm
): Promise<MessengerSubscriptionTokenResponse> => {
  const response = await axios.post<MessengerSubscriptionTokenResponse>(
    ENDPOINTS.app.messengerSubscriptionToken,
    data
  );
  return response.data;
};
